import { render, staticRenderFns } from "./logisticsBillDetails.vue?vue&type=template&id=4a0bdbb8&scoped=true"
import script from "./logisticsBillDetails.vue?vue&type=script&lang=js"
export * from "./logisticsBillDetails.vue?vue&type=script&lang=js"
import style0 from "./logisticsBillDetails.vue?vue&type=style&index=0&id=4a0bdbb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bdbb8",
  null
  
)

export default component.exports